import { render, staticRenderFns } from "./CustomDate.vue?vue&type=template&id=9b9854fa&scoped=true"
import script from "./CustomDate.vue?vue&type=script&lang=js"
export * from "./CustomDate.vue?vue&type=script&lang=js"
import style0 from "./CustomDate.vue?vue&type=style&index=0&id=9b9854fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9854fa",
  null
  
)

export default component.exports